import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    TextField as MuiTextField,
    TextFieldProps as MuiTextFieldProps,
} from '@material-ui/core';

type TextFieldProps = MuiTextFieldProps & {
    onEnter?: () => void,
};

TextField.defaultProps = {
    onEnter: () => {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        '& .MuiFormLabel-root.Mui-disabled': {
            color: '#001724',
        },
        '& .MuiFilledInput-root.Mui-disabled': {
            color: '#001724',
        },
    },
}));

function TextField(props: TextFieldProps): React.ReactElement {
    const {
        onEnter = TextField.defaultProps.onEnter,
        ...textFieldProps
    } = props;
    const classes = useStyle();

    return (
        <MuiTextField
            className={classes.root}
            variant={props.disabled ? 'filled' : 'outlined'}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    onEnter();
                }
            }}
            {...textFieldProps}
        />
    );
}

export { TextField };
